import styled, { css } from "styled-components";

import Text from "@/components/Text";
import { hexToRgba } from "@/utils/theme";

export const BackButton = styled.button`
  border-radius: 50%;
  transition: border ease-out 0.2s;
  display: inline-flex;
  align-items: center;
  transition: opacity ease-out 0.2s;
  svg {
    margin-right: 12px;
  }
  &:hover,
  &:active {
    opacity: 0.8;
  }
`;

export const InfoCardBox = styled.div`
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 32px;
  position: relative;
`;

export const InfoCardGroupsWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const InfoCardGroup = styled.div`
  width: 50%;
  grid-row-gap: 24px;
  border-right: 1px solid ${({ theme }) => theme.colors.lightGray};
  &:last-child {
    border-right: 0;
  }
  ${Text} {
    &:first-child {
      margin-bottom: 2px;
    }
  }
`;

export const InfoCardGroupFlexInner = styled.div`
  flex: 1;
`;

export const InfoCardItem = styled.div`
  margin-bottom: 24px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const InfoCardGroupFlex = styled(InfoCardGroup)`
  display: flex;
  padding-left: 24px;
  button {
    margin-left: 12px;
  }
`;

export const SelectionBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px;
`;

export const SelectionHeading = styled(Text)`
  margin-bottom: 6px;
`;

export const ControlsHolder = styled.div`
  display: flex;
  justify-content: right;
  margin-top: 24px;
`;

export const BatchBox = styled.div`
  background: ${({ theme }) => hexToRgba(theme.colors.grayscaleLight, 0.5)};
  padding: 24px 32px 32px;
  margin: 32px -32px 0;
`;

export const BatchBoxHeading = styled(Text)`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RemoveButton = styled.button`
  ${({ theme }) => css`
    font-family: ${theme.typography.button.fontFamily};
    font-weight: ${theme.typography.button.fontWeight};
    color: ${theme.colors.error};
    background: ${theme.colors.errorLight};
  `}
  border-radius: 4px;
  border: solid 1px transparent;
  padding: 0 11px;
  display: inline-flex;
  height: 27px;
  align-items: center;
  font-size: 11px;
  line-height: 15px;
  transition: border-color ease-out 0.2s;
  &:hover {
    border: solid 1px;
  }
`;

export const AddButtonHolder = styled.div`
  text-align: right;
  margin-top: 24px;
  svg {
    margin-right: 8px;
  }
  button {
    width: 100%;
  }
`;
